import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'


import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import { CATEGORY } from '../../utils/constants'
import WrappedMaterialForm from './components/MaterialForm'
import {
  getMaterial,
  createMaterial,
  updateMaterial,
  deleteMaterial,
  updateMaterialAdvance
} from '../../modules/material'
import WrappedUpdateAdvance from './components/UpdateAdvance';

const Materials = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [visibleAdvance, setAdvanceVisible] = useState(false)

  const { material, isLoading } = useSelector(
    (state) => ({
      material: state.material.material.data,
      isLoading: state.material.isLoading
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getMaterial())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await setVisible(false)
    // ทิ้งค่าที่แก้ค้างไว้ (เช่น ค่าที่ backend เพิ่งปฏิเสธ) ไม่ให้กลับมาตอนเปิดวัสดุเดิมอีกครั้ง
    await setFormData({})
  }
  const onCloseModalAdvance = async () => {
    await setAdvanceVisible(false)
  }

  const onOk = async (data) => {
    let success
    if (!_.isEmpty(formData)) {
      success = await dispatch(updateMaterial(data))
    } else {
      success = await dispatch(createMaterial(data))
    }

    // backend ปฏิเสธ (เช่น แก้หน่วยของวัสดุที่มีวัสดุของร้านผูกอยู่) → เปิดฟอร์มค้างไว้ให้แก้ต่อ
    if (success) {
      await dispatch(getMaterial())
      await setVisible(false)
      await setFormData({})
    }
    return success
  }
  const onOkAdvance = async (data) => {
    await dispatch(updateMaterialAdvance(data))
    await dispatch(getMaterial())
    await setAdvanceVisible(false)
    await setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deleteMaterial(id))
    await dispatch(getMaterial())
  }

  const refetchData = async () => { }

  const updateAdvance = (e, record) => {
    e.preventDefault()
    setAdvanceVisible(true)
    setFormData(record)
  }
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => (
        <div>
          {row.productImage && (
            <img
              src={row.productImage}
              width={64}
              height={64}
              style={{ marginRight: 10, objectFit: 'cover' }}
              alt="Product"
            />
          )}
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'English Name',
      dataIndex: 'engName',
      key: 'engName',
      ...getColumnSearchProps('engName'),
      render: (name, row) =>
        <span>
          {name ?
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={name.toString()}
            />
            : ''}
        </span>
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
      width: 150,
      filters: CATEGORY.map(category => ({
        text: category,
        value: category
      })),
      onFilter: (value, record) => record.category === value
    },
    {
      title: 'Common Name',
      dataIndex: 'commonName',
      key: 'commonName',
      ...getColumnSearchProps('commonName'),
      render: (name, row) => (
        <span>
          {name ?
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={name.toString()}
            />
            : ''}
        </span>
      )
    },
    {
      title: 'Common English Name',
      dataIndex: 'commonEngName',
      key: 'commonEngName',
      ...getColumnSearchProps('commonEngName'),
      render: (name, row) =>
        <span>
          {name ?
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={name.toString()}
            />
            : ''}
        </span>
    },
    {
      title: 'Advance',
      dataIndex: 'advance',
      key: 'advance',
      width: 150,
      ...getColumnSearchProps('advance'),
      render: (text, record) => <span style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) => updateAdvance(e, record)}>
        {text ? 'ขั้นสูง' : 'ทั่วไป'}
      </span>
    },
    {
      title: 'เปิดให้ผูก',
      dataIndex: 'allowCustomChild',
      key: 'allowCustomChild',
      width: 120,
      align: 'center',
      filters: [
        { text: 'Yes', value: true },
        { text: 'No', value: false }
      ],
      onFilter: (value, record) => !!record.allowCustomChild === value,
      render: (allowCustomChild) =>
        allowCustomChild ? <Tag color="green">Yes</Tag> : <Tag>No</Tag>
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </div>
      )
    }
  ]
  return (
    <Card
      title="Products"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New Product
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }
    >
      <Table
        loading={isLoading}
        scroll={{ x: 1300 }}
        rowKey={(record) => record.id}
        dataSource={material}
        columns={columns}
      />
      <WrappedUpdateAdvance
        visible={visibleAdvance}
        onOk={onOkAdvance}
        onCancel={onCloseModalAdvance}
        formData={formData}
      />
      <WrappedMaterialForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}
export default compose(
  withApollo
)(Materials)
